// @flow

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import FeedbackComponent from './feedback';
import { hasFAQFeedbackUrl } from '../../../helpers';
import {
  getFAQFeedbackForCurrentPath,
  getLoadingFeedbackComplete,
  hydrateFeedback as hydrateFeedbackAction,
  loadingFeedbackComplete,
  submitFAQFeedbackForCurrentPath,
} from '../../../store/feedback';
import {
  getTitle,
  getFeedbackWasHelpful,
  getFeedbackWasNotHelpful,
  getFeedbackWasPartiallyHelpful,
} from '../../../store/componentSettings/selectors';
import withErrorBoundary from '../../withErrorBoundary';
import type { FeedbackOptions } from '../../../store/feedback/types';

type OwnProps = {|
  className?: string,
|};

type StateProps = {|
  activeFeedback: string | boolean,
  loadingCompleted: boolean,
  title: string,
  wasHelpful: string,
  wasNotHelpful: string,
  wasPartiallyHelpful: string,
|};

type DispatchProps = {|
  completeLoadingFeedback: () => void,
  hydrateFeedback: () => void,
  onSubmit: (feedbackAnswer: FeedbackOptions) => void,
|};

type Props = OwnProps & StateProps & DispatchProps;

const FeedbackContainer = ({
  activeFeedback,
  className,
  completeLoadingFeedback,
  hydrateFeedback,
  loadingCompleted,
  onSubmit,
  title,
  wasHelpful,
  wasNotHelpful,
  wasPartiallyHelpful,
}: Props) => {
  const feedbackHydrateAndLoading = async () => {
    await hydrateFeedback();
    completeLoadingFeedback();
  };

  useEffect(() => {
    feedbackHydrateAndLoading();
  }, []);

  if (!hasFAQFeedbackUrl() || !loadingCompleted) {
    return null;
  }

  return (
    <FeedbackComponent
      activeFeedback={activeFeedback}
      canAnswer={!activeFeedback}
      className={className}
      onSubmit={onSubmit}
      title={title}
      wasHelpful={wasHelpful}
      wasNotHelpful={wasNotHelpful}
      wasPartiallyHelpful={wasPartiallyHelpful}
    />
  );
};

FeedbackContainer.defaultProps = {
  className: '',
};

const mapStateToProps = (state): StateProps => ({
  activeFeedback: getFAQFeedbackForCurrentPath(state),
  loadingCompleted: getLoadingFeedbackComplete(state),
  title: getTitle(state),
  wasHelpful: getFeedbackWasHelpful(state),
  wasNotHelpful: getFeedbackWasNotHelpful(state),
  wasPartiallyHelpful: getFeedbackWasPartiallyHelpful(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  completeLoadingFeedback: () => dispatch(loadingFeedbackComplete()),
  hydrateFeedback: () => dispatch(hydrateFeedbackAction()),
  onSubmit: (feedback: FeedbackOptions) => dispatch(submitFAQFeedbackForCurrentPath(feedback)),
});

export default withErrorBoundary<Props>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FeedbackContainer),
);
